/* GB: Monster Cart drawer tweaks (restored 2026-10-16 from the March suite the May sync dropped).
   1. Checkout button reads "CHECKOUT | $X" with the pre-savings total struck through.
   2. Savings row label reads "TOTAL SAVINGS".
   Values come from MC's own rendered attributes (button data-display, savings data-value), so the
   struck total always equals displayed total + displayed savings. Idempotent; writes only on change. */
(function () {
  function cents(s) {
    var m = String(s || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return m ? Math.round(parseFloat(m[1]) * 100) : 0;
  }
  function fmt(c) { return '$' + (c / 100).toFixed(2); }

  function apply() {
    var wrap = document.getElementById('monster-cart-wrapper');
    if (!wrap) return;

    var label = wrap.querySelector('[class*="mu:savings"] > span:first-child');
    if (label && label.textContent !== 'TOTAL SAVINGS') label.textContent = 'TOTAL SAVINGS';
    /* MC's flex-1 is a layered !important, which beats any unlayered stylesheet rule; inline wins. */
    if (label && label.style.getPropertyValue('flex') !== '0 0 auto') label.style.setProperty('flex', '0 0 auto', 'important');

    var btn = document.getElementById('mu-checkout-button');
    if (!btn) return;
    var inner = btn.querySelector(':scope > span');
    var txt = inner && inner.firstChild;
    if (txt && txt.nodeType === 3 && txt.nodeValue.indexOf('•') !== -1) {
      txt.nodeValue = txt.nodeValue.replace('•', '|');
    }

    var savEl = wrap.querySelector('[class*="mu:savings"] [data-value]');
    var total = cents(btn.getAttribute('data-display'));
    var saved = savEl ? cents(savEl.getAttribute('data-value')) : 0;
    var was = btn.querySelector('.gb-was');
    if (total > 0 && saved > 0) {
      var t = fmt(total + saved);
      if (!was) {
        was = document.createElement('del');
        was.className = 'gb-was';
        btn.appendChild(was);
      }
      if (was.textContent !== t) was.textContent = t;
    } else if (was) {
      was.remove();
    }
  }

  apply();
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-display', 'data-value'] });
})();
